import config from '../clientConfig';
import { HttpService } from 'common';
import UserStorage from '../utility/UserStorage';
import WindowService from './WindowService';

let processErrorResponse = (error) => {
    if (error.response && error.response.status === 401) {
        WindowService.window().location.replace("/login")
    } else {
        console.log(error);
    }
}
const httpService = new HttpService(config,UserStorage,processErrorResponse);

Object.freeze(httpService);

export default httpService;